const userRouters = [
  // 用户管理 - 其他
  {
    path: 'user',
    name: 'User',
    redirect: '/manage/system/user/list',
    component: () => import(/* webpackChunkName: "SystemMain" */ '@/views/content'),
    meta: {
      sidebar: 2,
      // 可查看用户列表的权限
      authKey: ['auth_user'],
      title: 'com_sider_menu_user',
      disabled: false,
      icon: 'menu_user2',
    },
    children: [
      // 用户管理 - 列表
      {
        path: 'list',
        name: 'UserList',
        component: () => import(/* webpackChunkName: "UserList" */ '@/views/system/user/list'),
        meta: {
          sidebar: false,
          authKey: ['auth_user', 'auth_user_list'],
          breadcrumb: false,
          title: 'com_sider_menu_user',
          disabled: false,
          icon: 'menu_user2',
        },
      },

      // 创建用户
      {
        path: 'add',
        name: 'UserAdd',
        component: () => import(/* webpackChunkName: "UserAdd" */ '@/views/system/user/update'),
        meta: {
          sidebar: false,
          authKey: ['auth_user', 'auth_user_add'],
          title: 'com_sider_menu_user_add',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },

      // 更新用户
      {
        path: 'update/:id',
        name: 'UserUpdate',
        component: () => import(/* webpackChunkName: "UserUpdate" */ '@/views/system/user/update'),
        meta: {
          sidebar: false,
          authKey: ['auth_user', 'auth_user_edit'],
          title: 'com_sider_menu_user_edit',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },

      // 用户授权
      {
        path: 'auth/:id',
        name: 'UserAuth',
        component: () =>
          import(/* webpackChunkName: "UserAuth" */ '@/views/system/user/authorization'),
        meta: {
          sidebar: false,
          authKey: ['auth_user', 'auth_user_authData', 'auth_user_customerStationList'],
          title: 'com_sider_menu_user_auth',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },

      // 用户详情
      {
        path: 'detail/:id',
        name: 'UserDetail',
        component: () => import(/* webpackChunkName: "UserDetail" */ '@/views/system/user/detail'),
        meta: {
          sidebar: false,
          authKey: ['auth_user', 'auth_user_detail'],
          title: 'com_sider_menu_user_detail',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },
    ],
  },
];

export default userRouters;
